export { TCSDocumentType } from './generated/TCSDocumentType.js';